import styled, { keyframes } from "styled-components";

/* Subtle pulse */
const orangeGlow = keyframes`
  0% { box-shadow: 0 0 10px rgba(255,140,0,0.3); }
  50% { box-shadow: 0 0 25px rgba(255,140,0,0.8); }
  100% { box-shadow: 0 0 10px rgba(255,140,0,0.3); }
`;

/* Section Wrapper */
export const EdgeSectionWrapper = styled.section`
  padding: 20px 20px;
  background: linear-gradient(180deg, #0d0d0d 0%, #1a1a1a 100%);
  color: white;
  position: relative;
  overflow: hidden;

  h3 {
    text-align: center;
    font-size: 1rem;
    color: orange;
    margin-bottom: 40px;
    letter-spacing: 1px;
  }

  /* PCB line effect */
  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(
      90deg,
      rgba(255,140,0,0.03),
      rgba(255,140,0,0.03) 2px,
      transparent 2px,
      transparent 6px
    );
    pointer-events: none;
  }
`;

/* Horizontal Scroll Container */
export const EdgeContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 30px;
  padding: 20px 10px;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: orange;
    border-radius: 10px;
    box-shadow: 0 0 5px orange;
  }

  &::-webkit-scrollbar-track {
    background: #111;
  }
`;

/* Individual Card */
export const EdgeCard = styled.div`
  scroll-snap-align: start;
  min-width: 220px;
  max-width: 240px;
  padding: 10px;
  border-radius: 18px;
  background: rgba(255, 140, 0, 0.05);
  border: 1px solid rgba(255, 140, 0, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s ease;
  animation: ${orangeGlow} 3s infinite;

  &:hover {
    transform: translateY(-10px) scale(1.03);
    box-shadow: 0 0 30px orange;
  }

  img {
    width: 35px;
    height: 35px;
    object-fit: contain;
    margin-bottom: 5px;
    filter: drop-shadow(0 0 6px orange);
  }

  h5 {
    font-size: 1rem;
    text-align: center;
  }

  @media (max-width: 768px) {
    min-width: 180px;
  }
`;